/* import __COLOCATED_TEMPLATE__ from './signup-service-selector.hbs'; */
import { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';
import { escapeRegExp } from 'sh-www/utils/misc';
import { SERVICES_DESCRIPTIONS } from 'sh-www/constants/services';

/** @type {function} */
const noop = () => { };

/**
 * @param {DS.Model} service
 * @returns {{ category?: string, value: number, key: string }}
 */
const mapServiceToOptions = (service) => {
  const { name: key, category } = service.getProperties(['name', 'category']);
  const props = { key, service };

  if (category) {
    props.category = category;
  }

  const tooltip = SERVICES_DESCRIPTIONS[key]?.description;
  if (tooltip) {
    props.tooltip = tooltip;
  }

  return props;
};

/** @module */
const SignupServiceSelector = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {boolean} */
  disabled: false,

  /** @type {Ember.A} */
  options: A([]),

  /** @type {Ember.A} */
  selected: A([]),

  /** @type {string} */
  label: '',

  /** @type {string} */
  _internalValue: '',

  /** @type {function(DS.Model): { key: string, service: DS.Model, category?: string }} */
  mapServiceToOptions,

  /** @type {Ember.ComputedProperty} */
  _mappedServices: computed('options.[]', 'mapServiceToOptions', function() {
    return this.get('options').map(this.get('mapServiceToOptions'));
  }),

  /** @type {Ember.ComputedProperty} */
  _selectedServices: computed('selected.[]', 'mapServiceToOptions', function() {
    return this.get('selected').map(this.get('mapServiceToOptions'));
  }),

  /** @type {Ember.ComputedProperty} */
  _filteredServices: computed('_internalValue', '_mappedServices.[]', function() {
    const { _internalValue, _mappedServices } = this.getProperties(['_internalValue', '_mappedServices']);

    if (!_internalValue) {
      return _mappedServices;
    }

    const escapedInternalValue = escapeRegExp(_internalValue);

    return _mappedServices.filter(({ key }) => {
      const pattern = new RegExp(`(\\b${escapedInternalValue})`, 'ig');
      return pattern.test(key);
    });
  }),

  /** @inheritDoc */
  actions: {
    /**
     *
     */
    handleBlur() {
      this.set('_internalValue', '');
      this.get('onblur')?.();
    },

    /**
     * @param {string} value
     */
    handleInput(value) {
      this.set('_internalValue', value);
    },

    /**
     * @param {Object} obj
     * @param {DS.Model} obj.service
     */
    handleAdded({ service }) {
      this.set('_internalValue', '');

      const index = this.get('selected').findIndex((s) => {
        return service.get('id') === s.get('id');
      });

      if (index === -1) {
        this.get('onadded')?.(service);
      }
    },

    /**
     * @param {Object} obj
     * @param {DS.Model} obj.service
     */
    handleRemoved({ service }) {
      this.get('onremoved')?.(service);
    },
  },
});

export default SignupServiceSelector;
